import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { GTable, IGColumnProps } from '../../../../__legacy__/components/table/GTable';
import { CheckMarkIcon } from '../../../../design/static/icons/CheckMarkIcon';
import { CrossIcon } from '../../../../design/static/icons/CrossIcon';
import { DescriptionValue, GetWorkspaceActions, IWorkspaceAction } from '../models/WorkspaceActions';

export const WorkspaceActionsTable = (): ReactElement => {
  const { t } = useTranslator();

  const columns: IGColumnProps<IWorkspaceAction>[] = [
    {
      headerName: t('teams.workspace_actions.table.headers.actionType'),
      renderer: (item: IWorkspaceAction) => <div className='text-justify'>{t(`teams.workspace_actions.table.action_types.${item.id}`)}</div>,
    },
    {
      headerName: t('teams.workspace_actions.table.headers.worker'),
      renderer: (item: IWorkspaceAction) => renderPermission(item.worker),
      width: '10%',
    },
    {
      headerName: t('teams.workspace_actions.table.headers.assistant'),
      renderer: (item: IWorkspaceAction) => renderPermission(item.assistant),
      width: '10%',
    },
    {
      headerName: t('teams.workspace_actions.table.headers.guest'),
      renderer: (item: IWorkspaceAction) => renderPermission(item.guest),
      width: '10%',
    },
    {
      headerName: t('teams.workspace_actions.table.headers.collaborator'),
      renderer: (item: IWorkspaceAction) => renderPermission(item.collaborator),
      width: '10%',
    },
    {
      headerName: t('teams.workspace_actions.table.headers.developer'),
      renderer: (item: IWorkspaceAction) => renderPermission(item.developer),
      width: '10%',
    },
    {
      headerName: t('teams.workspace_actions.table.headers.trainer'),
      renderer: (item: IWorkspaceAction) => renderPermission(item.trainer),
      width: '10%',
    },
    {
      headerName: t('teams.workspace_actions.table.headers.manager'),
      renderer: (item: IWorkspaceAction) => renderPermission(item.manager),
      width: '10%',
    },
    {
      headerName: t('teams.workspace_actions.table.headers.owner'),
      renderer: (item: IWorkspaceAction) => renderPermission(item.owner),
      width: '10%',
    },
  ];

  const renderPermission = (value: DescriptionValue | boolean): ReactElement => {
    return typeof value === 'boolean' ? <>{value ? <CheckMarkIcon /> : <CrossIcon />}</> : <>{t(`teams.workspace_actions.table.${value}`)}</>;
  };

  return (
    <div className='workspace-actions-table-container'>
      <GTable
        isLoading={false}
        noItemsPlaceholder=''
        columns={columns}
        items={GetWorkspaceActions()}
      />
    </div>
  );
};
